module.exports = __webpack_public_path__ + "static/mapple.17917761.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/mapple.webp
// module id = 919
// module chunks = 3